(function ($) {
  $(document).ready(function () {
    // ---------------------------
    // 1️⃣ Focus Trap for #goodg-app
    // ---------------------------
    setTimeout(function () {
      $("#goodg-app").attr("tabindex", "0").focus();

      const $trapArea = $('#goodg-app');
      const $closeBtn = $('.goodg-cart__close');

      // Make close button focusable
      $closeBtn.attr('tabindex', '0');

      // Focus trap setup
      const focusableSelectors = 'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])';
      let $focusableEls, firstFocusable, lastFocusable;

      function trapFocus() {
        $focusableEls = $trapArea.find(focusableSelectors).filter(':visible');
        firstFocusable = $focusableEls.first();
        lastFocusable = $focusableEls.last();

        $trapArea.on('keydown', function (e) {
          const key = e.key;

          // Handle focus trap (Tab key)
          if (key === 'Tab') {
            if (e.shiftKey) {
              if ($(document.activeElement).is(firstFocusable)) {
                e.preventDefault();
                lastFocusable.focus();
              }
            } else {
              if ($(document.activeElement).is(lastFocusable)) {
                e.preventDefault();
                firstFocusable.focus();
              }
            }
          }

          // Handle Enter key on .goodg-cart__close
          if (key === 'Enter' && $(document.activeElement).is($closeBtn)) {
            e.preventDefault();
            $closeBtn.trigger('click');
          }

          // Handle ESC key anywhere inside #goodg-app
          if (key === 'Escape') {
            e.preventDefault();
            $closeBtn.trigger('click');
          }
        });
      }

      // Start focus trap
      trapFocus();

    }, 1500);


    // ---------------------------
    // 2️⃣ MutationObserver for .minmaxify-p-wrap
    // ---------------------------
    const focusableSelectors = 'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])';

    function trapFocusWrap($container) {
      const $focusableEls = $container.find(focusableSelectors).filter(':visible');
      const $first = $focusableEls.first();
      const $last = $focusableEls.last();
      const $closeBtn = $container.find('.goodg-cart__close');

      // Make close button focusable
      $closeBtn.attr('tabindex', '0');

      // Focus first focusable element
      if ($first.length) {
        setTimeout(() => $first.focus(), 600);
      }
      
      // Key handling for focus trap, Enter, and Escape
      $container.on('keydown.trap', function (e) {
        const key = e.key;

        // Focus trap with Tab / Shift+Tab
        if (key === 'Tab') {
          if (e.shiftKey && $(document.activeElement).is($first)) {
            e.preventDefault();
            $last.focus();
          } else if (!e.shiftKey && $(document.activeElement).is($last)) {
            e.preventDefault();
            $first.focus();
          }
        }

        // Trigger close on Enter or Escape
        if (key === 'Enter' && $(document.activeElement).is($closeBtn)) {
          e.preventDefault();
          $closeBtn.trigger('click');
        }
        if (key === 'Escape') {
          e.preventDefault();
          $closeBtn.trigger('click');
        }
      });
    }

    // Watch DOM for dynamically added .minmaxify-p-wrap
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if ($(node).is('.minmaxify-p-wrap')) {
            trapFocusWrap($(node));
          } else if ($(node).find('.minmaxify-p-wrap').length) {
            trapFocusWrap($(node).find('.minmaxify-p-wrap'));
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });


  

})(jQuery);


  